import {
  Connection,
  Internal,
  WorkflowConnection,
} from '../../PayItemsModuleContext/types'
import {
  EditPayItemSummaryOrderInput,
  InternalPayItemConnectionOrderInput,
  PayItemConnectionGroupOrderInput,
  PayItemConnectionOrderInput,
  WorkflowPayItemSummaryOrderInput,
} from 'schema'
import { Order } from './types'

export function buildEditPayItemSummaryOrderInput(
  projectId: string,
  orders: Order[]
): EditPayItemSummaryOrderInput {
  const connections = Array<PayItemConnectionOrderInput>()
  const internalConnections = Array<InternalPayItemConnectionOrderInput>()
  const groups = Array<PayItemConnectionGroupOrderInput>()
  const workflowConnections = Array<WorkflowPayItemSummaryOrderInput>()
  const addConnection = (
    connection: Exclude<Order, { __typename: 'PayItemConnectionGroup' }>,
    order: number,
    groupId: string | null
  ) => {
    if (connection.__typename === 'PayItemConnection')
      connections.push({ id: connection.id, order, groupId })
    else if (connection.__typename === 'ProjectToInternalConnection')
      internalConnections.push({
        internalConnectionId: connection.id,
        order,
        groupId,
      })
    else
      workflowConnections.push({
        workflowId: connection.id,
        order,
        groupId,
      })
  }

  orders.forEach((item, order) => {
    if (item.__typename === 'PayItemConnectionGroup') {
      groups.push({ id: item.id, order })
      item.children.forEach((child, childOrder) =>
        addConnection(child, childOrder, item.id)
      )
    } else addConnection(item, order, null)
  })

  return {
    projectId,
    connections,
    internalConnections,
    groups,
    workflowConnections,
  }
}

export function getLabel(item: Internal | Connection | WorkflowConnection) {
  if (item.__typename === 'ProjectToInternalConnection')
    return item.internal.module.name
  else if (item.__typename === 'PayItemConnection')
    return (
      item.name ??
      item.googleSheet?.title ??
      item.googleSheet?.compositeId ??
      'Connection'
    )
  else if (item.__typename === 'WorkflowPayItemSummaryConnection')
    return item.workflow.label
  return 'Connection'
}
